/**
 * Theme preference cookie — SSR-readable mirror of next-themes' localStorage.
 * Safe to import from Server Components (no "use client").
 */

export const THEME_COOKIE_NAME = "axp-theme";

/** Previous cookie name; read as fallback and cleared on write. */
export const LEGACY_THEME_COOKIE_NAME = "boreal-theme";

type CookieReader = {
  get: (name: string) => { value: string } | undefined;
};

/** Prefer `axp-theme`, fall back to legacy `boreal-theme` during migration. */
export function readThemeCookie(cookies: CookieReader): string | undefined {
  return cookies.get(THEME_COOKIE_NAME)?.value ?? cookies.get(LEGACY_THEME_COOKIE_NAME)?.value;
}
